module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGbca9bb9cef0cbf56bab9f455cd7f61f5.bca9bb9c.png";